import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { CenteredGuestContainer } from '../components/Container';
import logo from '../assets/images/logo.svg';

const GuestLayout: React.FC<{ children: ReactElement }> = ({ children }) => {
    return (
        <CenteredGuestContainer>
            <Box textAlign={"center"}>
                <Link to="/" reloadDocument={true}>
                    <img src={logo} />
                </Link>
                <Link to="/" reloadDocument={true}>
                    <Typography fontWeight={"bold"} variant="h6">Clinic Tools</Typography>
                </Link>
            </Box>
            {children}
        </CenteredGuestContainer>
    );
};

export default GuestLayout;
